/* eslint jsx-a11y/label-has-for: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';

const RadioButton = props => (
    <div className={`${css.RadioButton} radio-button`}>
        <input {...props} type="radio" />
        <label />
    </div>
);

RadioButton.propTypes = {
    onchange: PropTypes.func
};

export default RadioButton;



// WEBPACK FOOTER //
// ./app/components/radiobutton/index.js